import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import type { LightingCategory } from '../../data/christmasLighting';
import { business } from '../../data/business';
type LightingServiceDetailProps = {
  category: LightingCategory;
};

// Shared starter layout for the Residential and Commercial lighting pages.
// Add more sections below the intro as you expand each service.
export function LightingServiceDetail({
  category
}: LightingServiceDetailProps) {
  return <main id="main" className="w-full bg-cream" data-id="element-163" data-mp="8ybh30zs6r1c">
      <section aria-labelledby="service-title" className="mx-auto max-w-7xl px-5 py-12 sm:px-8 md:py-20" data-id="element-164" data-mp="8x0db16c5ja8">
        <nav aria-label="Breadcrumb" data-id="element-165" data-mp="ip6gz85y9p59">
          <Link to="/christmas-lights" className="inline-flex items-center gap-2 text-sm font-semibold text-olive transition-colors hover:text-forest" data-id="element-166" data-mp="io4so1zxb65l">
            <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-167" data-mp="rpb96b2kogyu" /> Christmas Lights
          </Link>
        </nav>

        <div className="mt-8 grid items-center gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-168" data-mp="3t7p4yqj7vphi">
          <div data-id="element-169" data-mp="3p4j0nofo08do">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-olive" data-id="element-170" data-mp="3p3zic6m3rhz4">{category.eyebrow}</p>
            <h1 id="service-title" className="mt-4 font-display text-4xl font-medium leading-[1.05] tracking-tight text-forest sm:text-5xl lg:text-6xl" data-id="element-171" data-mp="3k6r0660yfdxv">
              {category.title}
            </h1>
            <p className="mt-6 text-lg leading-relaxed text-forest/70" data-id="element-172" data-mp="gnxs28qy3hb3">{category.description}</p>
            <Link to={business.quoteHref} className="mt-10 inline-flex h-14 items-center justify-center rounded-full bg-olive px-8 text-[13px] font-bold uppercase tracking-[0.08em] text-white transition-colors hover:bg-olive-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2" data-id="element-173" data-mp="brh35cbx8ywy">
              Get Your Quote
            </Link>
          </div>
          <div className="overflow-hidden rounded-[2rem] shadow-[0_30px_60px_-30px_rgba(38,58,41,0.5)]" data-id="element-174" data-mp="umxi9ku3w49d">
            <img src={category.image} alt={category.alt} className="aspect-[4/3] w-full object-cover" data-id="element-175" data-mp="2oz8cdvxkdtrp" />
          </div>
        </div>
      </section>
    </main>;
}